import React, {useEffect, useRef, useState} from 'react';
import './scss/user-cards.scss';
import StatusView from "./status-view";
import Layout from "./layout";
import FullScreenLoader from "./full-screen";
import SogApi from "../services/sogApi";
import ICard from "../models/card";
import ICardLevel from "../models/card-level";
import ICardFilter from "../models/cards-filter";
import CardsFilter from "./cards-filter";
import {Button} from 'react-bootstrap';
import EmptyView from "./empty-view";
import ICardExpanded from "../models/card-expanded";
import SelectSoGEnvComponent from "./select-sog-env-component";
import IStatusMessage from "../models/status-message";
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function UserCards(): React.ReactElement {
    const filterRef = useRef() as any;
    const emptyStatus: IStatusMessage = {message: '', type: StatusMessageTypeEnum.none}
    const [statusMessage, setStatusMessage] = useState(emptyStatus);
    const [isLoading, setIsLoading] = useState(false);
    const [cardsFetched, setCardsFetched] = useState(false);
    const [username, setUsername] = useState("");
    const defaultUserCards: ICardExpanded[] = [];
    const defaultCards: ICard[] = [];

    const dColor: any = {}
    const [colorMap, setColorMap] = useState(dColor);

    const [filteredCards, setFilteredCards] = useState(defaultUserCards);
    const [allCards, setAllCards] = useState(defaultCards);
    const [allUserCards, setAllUserCards] = useState(defaultUserCards);


    const searchUser = () => {
        fetchUserCards()
    }
    const generateColor = () => {
        const hexColor = Math.floor(Math.random() * 16777215).toString(16);
        const alphaValue = '17';
        return `#${hexColor}${alphaValue}`;
    };

    const assignColors = (userCards: ICardExpanded[]) => {
        const uniqueUnids = [...new Set(userCards.map(item => item.unid))];
        const colors: any = {};
        uniqueUnids.forEach(unid => {
            colors[unid] = generateColor();
        });
        setColorMap(colors);
    };

    const applyFilter = (filter: ICardFilter) => {
        let fCards = allUserCards.filter(card => {
            if (
                (filter.name && filter.name !== '') ||
                (filter.level?.blockchain !== undefined) ||
                (filter.level?.unid !== undefined) ||
                (filter.playerCardLevelId !== undefined)
            ) {
                return filterValidations(card, filter);
            }
            return true;
        })
        setFilteredCards(fCards)
    }

    const filterValidations = (card: ICardExpanded, filter: ICardFilter) => {
        let nameFilter = (!filter.name || card.name?.toLowerCase().includes(filter.name.toLowerCase()));
        let blockchainFilter = filter.level?.blockchain === undefined || card.blockchain == filter.level?.blockchain
        let levelIdFilter = filter.level?.unid === undefined || filter.level?.unid == 0 || card.levelId?.toString().includes(filter.level?.unid?.toString());
        let playerCardLevelIdFilter = filter.playerCardLevelId === undefined || filter.playerCardLevelId == 0 || card.playerCardLevelId?.toString().includes(filter.playerCardLevelId?.toString());
        return nameFilter && blockchainFilter && levelIdFilter && playerCardLevelIdFilter;
    }

    useEffect(() => {
        if (!cardsFetched) {
            fetchCards();
        } else {
            fetchUserCards()
        }
    }, [cardsFetched]);

    const fetchUserCards = () => {
        if (username?.length == 0) {
            setIsLoading(false);
            return
        }
        ;
        setStatusMessage(emptyStatus);
        filterRef?.current?.reset();
        let userCards: ICardExpanded[] = []
        setIsLoading(true);
        SogApi.getUserCollection(username).then(collection => {
            allCards?.forEach(card => {
                let cardLevels: ICardLevel[] = card.levels;
                let cardLevelsFound: ICardLevel[] = [];
                collection?.forEach((coll: { cardLevel: number; blockchain: boolean, id: number }) => {
                    let levels = cardLevels.filter(level => {
                        return level.unid == coll.cardLevel
                    });
                    levels = levels.map(l => {
                        return {
                            ...l,
                            blockchain: coll.blockchain || false,
                            id: coll.id
                        }
                    })
                    if (levels?.length > 0) {
                        cardLevelsFound.push(...levels)
                    }
                })
                if (cardLevelsFound?.length > 0) {
                    cardLevelsFound.forEach(l => {
                        userCards.push(
                            {
                                ...card,
                                ...l,
                                levelId: l.unid,
                                unid: card.unid,
                                playerCardLevelId: l.id,
                                imageUrl: "https://api.moonga.com/gw_admin/img/cards/generated/card_" + card.moongaId + "_small.jpg"
                            }
                        )
                    })
                }
            })
            setAllUserCards(userCards)
            setFilteredCards(userCards)
            assignColors(userCards);
            setIsLoading(false);
        }).catch(e => {
            setStatusMessage({message: e.message, type: StatusMessageTypeEnum.error})
            console.error(e)
            setIsLoading(false);
        })
    }

    const fetchCards = () => {
        setStatusMessage(emptyStatus);
        setIsLoading(true);
        SogApi.getAllCards().then((data: ICard[]) => {
            setAllCards(data)
            setCardsFetched(true)
        }).catch(e => {
            setStatusMessage({message: e.message, type: StatusMessageTypeEnum.error})
            console.error(e)
            setIsLoading(false);
        })
    }

    return (
        <Layout className="page user-cards loading-wrapper">
            <StatusView status={statusMessage}/>
            {isLoading ? <FullScreenLoader/> : <div/>}
            <div className="normal-text-italic search">
                <div className="row justify-content-center">
                    <div className="col-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Username"
                            onChange={(e) => setUsername(e.target.value.toString())}
                        />
                    </div>
                    <div className="col-3">
                        <Button className="w-100" variant="primary"
                                onClick={searchUser}>
                            Search Cards
                        </Button>
                    </div>
                    <div className="col-3">
                        <div className="d-inline-block">
                            <SelectSoGEnvComponent></SelectSoGEnvComponent>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-md-12 text-center">
                        <CardsFilter ref={filterRef} onApplyFilter={applyFilter}></CardsFilter>
                    </div>
                </div>
                <div className="row pt-4">
                    <div className="col-md-12">
                        <table className="cards-table">
                            <thead>
                            <tr>
                                <th># ({filteredCards.length})</th>
                                <th>Image</th>
                                <th>On Chain</th>
                                <th>Player Card Level Id</th>
                                <th>Card Id</th>
                                <th>Card Level Id</th>
                                <th>Moonga Id</th>
                                <th>Name</th>
                                <th>Rarity</th>
                                <th>Element</th>
                                <th>Evolution Rank</th>
                                <th>Family</th>
                                <th>Attack</th>
                                <th>Health</th>
                                <th>Speed</th>
                                <th>Spell Name</th>
                                <th>Spell Strength</th>
                            </tr>
                            </thead>
                            <tbody>
                            {(filteredCards?.length > 0) ?
                                (
                                    filteredCards.map((card: ICardExpanded, index: any) => (
                                        <tr key={index + 1}
                                            style={{backgroundColor: colorMap[card.unid]}}>
                                            <td>{index + 1}</td>
                                            <td>
                                                <img
                                                    src={card.imageUrl}
                                                    alt={`Image ${index + 1}`}
                                                    style={{width: '100px', height: 'auto'}}/>
                                            </td>
                                            <td>{card.blockchain ? "yes" : "no"}</td>
                                            <td>{card.playerCardLevelId}</td>
                                            <td>{card.unid}</td>
                                            <td>{card.levelId}</td>
                                            <td>{card.moongaId}</td>
                                            <td>{card.name}</td>
                                            <td>{card.rarity}</td>
                                            <td>{card.element}</td>
                                            <td>{card.evolutionRank}</td>
                                            <td>{card.family}</td>
                                            <td>{card.attack}</td>
                                            <td>{card.health}</td>
                                            <td>{card.speed}</td>
                                            <td>{card.spellName}</td>
                                            <td>{card.spellStrength}</td>
                                        </tr>
                                    ))
                                )
                                : (
                                    <tr key={1}>
                                        <td colSpan={17}>
                                            <EmptyView title={"Records not found"}
                                                       desc={"Seems like user does not have any cards in his/her collection"}></EmptyView>
                                        </td>
                                    </tr>

                                )
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Layout>
    );

}

export default UserCards;
